// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"He","landingPageVideo":"Ie","play":"Je","iframeVideo":"Ke","playHidden":"Le","playVisible":"Me","fullwidth":"Ne"};